import RequestService, {getQueryURL} from '../requestService';

import {client} from '../../client';
import {PaginatedResult} from '../../../models/paginatedResult';
import {Systemparameter} from '../../../models';
import {Applikasjon} from '../../../models/applikasjon';
import {MessageRequiredAnswer} from '../../../models/messageRequiredAnswer';
import {FieldFilter} from '../../../app/utils/filter';


export default class SystemparameterService extends RequestService<Systemparameter, 'systemparameter'> {  
    applikasjoner = async (searchString: string) => client.get<PaginatedResult<Applikasjon>>(`${this.serviceName}/hentApplikasjoner?q=${encodeURIComponent(searchString)}`);
    typer = async (searchString: string) => client.get<PaginatedResult<string>>(`${this.serviceName}/hentTyper?q=${encodeURIComponent(searchString)}&disablePagination=true`);
    parentSystemparameter = async (searchString: string) => client.get<PaginatedResult<string>>(`${this.serviceName}/hentParentSystemparameter?q=${encodeURIComponent(searchString)}&disablePagination=true`);
    eksportTilXmlById = async (id: string) => await client.getFile(`${this.serviceName}/${encodeURIComponent(id)}/xml-eksport`, 'GET');
    eksportAlleTilXml = async () => await client.getFile(`${this.serviceName}/xml-eksport`, 'GET');
    eksportScriptFile = async (id: string | number) => await client.getFile(`${this.serviceName}/eksport_systemparameter_script/${encodeURIComponent(id)}`, 'GET');
    sjekkParameter = async (id: string, fieldValue: FieldFilter) => {
        return client.post<boolean>(`${this.serviceName}/${encodeURIComponent(id)}/sjekk_parameter`, fieldValue);
    };
    importFromXML = async (fileContent: Blob, filNavn: string) => {
        try {
            const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/xml-import`, {filNavn}), fileContent);
            return {success: true, msg: res.message};
        } catch (err) {
            return {success: false, msg: (err as Error).message};
        }
    };
}

